import React, { Fragment } from 'react';
import parkinghub from '../../../../../images/parkinghub.jpeg';
import '../../driverFaq.css';
import PersonalVehicleAccess from './PersonalVehicleAccess';
import WalkingAccess from './WalkingAccess';

const ParkingHub = () => (
  <Fragment>
    <p style={{ color: 'grey' }}>Toronto Downtown</p>
    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
      <li>Location: Omni Park Facility at the Thompson Residences</li>
      <li>Address: 621 King St. West, (P4) Toronto, ON M5V 1M5</li>
      <li>
        Intersection: Bathurst St./King. St. West. with access on King
        Street West
      </li>
      <li>Closest subway stations: St. Andrew subway station</li>
    </ul>
    <br />
    <div style={{ width: '100%' }}>
      <img src={parkinghub} className="hub-location-image" />
    </div>
    <br />
    <p>
      The parking lot is a short walk from St. Andrew and Union subway
      stations, and easily accessible by streetcars from both St. Andrew
      and Bathurst subway stations. (Route 504/514 on King St. West and
      Route 511 on Bathurst St.)
    </p>
    <br />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot by walking?
    </p>
    <WalkingAccess />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot with my personal vehicle? (free
      parking)
    </p>
    <PersonalVehicleAccess />
  </Fragment>
);

export default ParkingHub;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/King/ParkingHub.js